export default function () {
  function calculator(data) {
    if (!data || data.length === 0) return [];

    const len = data.length;
    const results = new Array(len);

    // Detect if periodicity is daily or higher by checking time difference between bars
    let isDailyOrHigher = false;
    if (len >= 2) {
      for (let i = 1; i < Math.min(len, 10); i++) {
        if (data[i].date && data[i - 1].date) {
          const timeDiff = data[i].date - data[i - 1].date;
          const hoursDiff = timeDiff / (1000 * 60 * 60);
          // If bars are more than 12 hours apart, it's daily or higher
          if (hoursDiff > 12) {
            isDailyOrHigher = true;
            break;
          }
        }
      }
    }

    // VWAP is only valid for intraday periods
    if (isDailyOrHigher) {
      // Return error flag
      for (let i = 0; i < len; i++) {
        results[i] = "INTRADAY_ONLY";
      }
      return results;
    }

    let cumVol = 0;
    let cumVolPrice = 0;
    let lastDateStr = null;

    for (let i = 0; i < len; i++) {
      const d = data[i];

      if (!d || d.high == null || d.low == null || d.close == null) {
        results[i] = undefined;
        continue;
      }

      // Check for new trading day and reset
      if (d.date) {
        const dt = d.date;
        const dateStr = `${dt.getFullYear()}-${dt.getMonth()}-${dt.getDate()}`;

        if (lastDateStr !== null && lastDateStr !== dateStr) {
          // New day detected - reset cumulative values
          cumVol = 0;
          cumVolPrice = 0;
        }

        lastDateStr = dateStr;
      }

      // Extract volume value (handle both number and object {volume: number, direction: string})
      let vol = d.volume;
      if (typeof vol === "object" && vol !== null) {
        vol = vol.volume;
      }

      if (vol == null || vol <= 0) {
        results[i] = undefined;
        continue;
      }

      const tp = (d.high + d.low + d.close) / 3;
      cumVol += vol;
      cumVolPrice += tp * vol;

      results[i] = cumVol > 0 ? cumVolPrice / cumVol : undefined;
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return {};
    }
    return calculator;
  };

  return calculator;
}
